import { Helmet, HelmetProvider } from "react-helmet-async";

const HelmetLayout = ({ children, name, title, description, route }) => {
    const mainDomain = "https://ardaltaamir.ae";
    const mirrorDomain = "https://ardaltaamir.com";

    return (
        <HelmetProvider>
            <Helmet>
                <title>Ard Altaamir | {name}</title>
                <meta name="title" content={title} />
                <meta property="og:title" content={title} />
                <meta property="twitter:title" content={title} />

                <meta name="description" content={description} />
                <meta property="og:description" content={description} />
                <meta property="twitter:description" content={description} />

                <meta property="og:image" content="preview.png" />
                <meta property="og:type" content="website" />
                <meta property="twitter:image" content="preview.png" />
                <meta property="twitter:card" content="summary_large_image" />

                <meta property="og:url" content={`${mainDomain}/en/${route}`} />
                <link rel="canonical" href={`${mainDomain}/en/${route}`} />
                <link rel="alternate" href={`${mainDomain}/en/${route}`} hrefLang="en" />
                <link rel="alternate" href={`${mirrorDomain}/en/${route}`} hrefLang="en" />
                <link rel="alternate" href={`${mainDomain}/en`} hrefLang="x-default" />
            </Helmet>
            <div className="ovf-hidden">
                {children}
            </div>
        </HelmetProvider>
    );
};

export default HelmetLayout;